import { NotificationType } from "@/types/notification";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class HitRateStatus extends Vue {
  hitRateStatus(hitRate: number) {
    let type: NotificationType = NotificationType.DEFAULT;
    const message = `Hit rate is the main measure of performance for your cache, generally you should strive for a hit rate of above 80%`;

    const good = 0.8; // > 80%
    const average = 0.5; // > 50%
    // < 50% bad

    if (hitRate >= good) {
      type = NotificationType.SUCCESS;
    } else if (hitRate >= average) {
      type = NotificationType.WARNING;
    } else if (hitRate !== null) {
      type = NotificationType.ERROR;
    }

    return { type, message };
  }
}
